export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12410.b59d8258.jpg";